import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { useECommerceProduct } from "@/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { useProductDetail } from "@/components/Product/ECommerce/hooks/useProductDetail.hook";

type Props = {
    className?: string;
    children: ReactNode;
};

export const StickyWrapper = ({ className, children }: Props) => {
    const { hasComparisonSkus } = useECommerceProduct();
    const { stickyOrderButton } = useProductDetail();

    return (
        <div
            className={cn(
                "tw:fixed tw:bottom-0 tw:left-0 tw:right-0 tw:md:right-auto tw:layer-overlay/[0]",
                "tw:p-2 tw:md:hidden",
                "tw:bg-background",
                {
                    "tw:hidden": !stickyOrderButton,
                    "tw:right-1/2": hasComparisonSkus
                },
                className
            )}
        >
            {children}
        </div>
    );
};
